// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInCalendarDays/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInCalendarDays = convertToFP(fn, 2);
export default differenceInCalendarDays;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInCalendarDays/index.js
// module id = 827
// module chunks = 0